import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import mutations from '../../../../graphql/mutations';

import style from './index.module.scss';

const {
  topicMutations: { FOLLOW_TOPIC, BOOKMARK_TOPIC },
} = mutations;

// Check if user is already following topic
const isUserFollowingTopic = (userId, topic) => {
  return topic.followedBy.includes(userId);
};

// Check if user has already bookmarked topic
const hasUserBookmarkedTopic = (userId, topic) => {
  return topic.bookmarkedBy.includes(userId);
};

function HeaderActions({ topic }) {
  const [isFollowing, setIsFollowing] = useState(
    isUserFollowingTopic('5d0959b4b6b2c911c8b4ae04', topic) || false
  );
  const [hasBookmarked, setHasBookmarked] = useState(
    hasUserBookmarkedTopic('5d0959b4b6b2c911c8b4ae04', topic) || false
  );

  const handleFollow = followTopic => {
    setIsFollowing(!isFollowing);

    followTopic({
      variables: {
        topicId: topic.id,
        followedBy: '5d0959b4b6b2c911c8b4ae04',
      },
    });
  };

  const handleBookmark = bookmarkTopic => {
    setHasBookmarked(!hasBookmarked);

    bookmarkTopic({
      variables: {
        topicId: topic.id,
        bookmarkedBy: '5d0959b4b6b2c911c8b4ae04',
      },
    });
  };

  const updateCache = (cache, { data }) => {
    console.log('Cache', cache);
    console.log('Follow Topic', data.followTopic);
    console.log('Bookmark Topic', data.bookmarkTopic);
  };

  return (
    <div className={`row`}>
      <div className={style['col-follow']}>
        <Mutation mutation={FOLLOW_TOPIC} update={updateCache}>
          {followTopic => (
            <div className={style['topic-follow']}>
              <div
                onClick={() => handleFollow(followTopic)}
                className={style.action}
              >
                {isFollowing ? (
                  <>
                    <i className='fas fa-id-card'></i>
                    <span className={style['topic-label']}> Following</span>
                  </>
                ) : (
                  <>
                    <i className='far fa-id-card'></i>
                    <span className={style['topic-label']}> Follow</span>
                  </>
                )}
              </div>
              <span
                className={`${style['topic-label']} ${
                  style['topic-label--followers']
                }`}
              >
                {' '}
                {topic.followedBy.length}
              </span>
            </div>
          )}
        </Mutation>
      </div>
      <div className={style['col-bookmark']}>
        <Mutation mutation={BOOKMARK_TOPIC} update={updateCache}>
          {bookmarkTopic => (
            <div className={style['topic-bookmark']}>
              <div
                onClick={() => handleBookmark(bookmarkTopic)}
                className={style.action}
              >
                {hasBookmarked ? (
                  <>
                    <i className='fas fa-bookmark'></i>
                    <span className={style['topic-label']}> Bookmarked</span>
                  </>
                ) : (
                  <>
                    <i className='far fa-bookmark'></i>
                    <span className={style['topic-label']}> Bookmark</span>
                  </>
                )}
              </div>
            </div>
          )}
        </Mutation>
      </div>
    </div>
  );
}

HeaderActions.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.string.isRequired,
    followedBy: PropTypes.array.isRequired,
  }).isRequired,
};

export default HeaderActions;
